import { RichText } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import InfoToolTip from '../../../../@shared/infoToolTip';
import { TLeftMostCellProps } from '../../../types/index.types';

const TableLeftMostCell: FC<TLeftMostCellProps> = (props) => {
  const { row } = props;
  return (
    <>
      {row.title && <RichText field={row.title} editable={true} className="rich-text" />}
      <InfoToolTip
        className="model-detail-specification-table__info-icon model-detail-specification-table__info-icon--editorial-table"
        iconClassName="table-info-icon"
        showIcon={Boolean(row.tooltip?.value)}
        width={300}
      >
        <div className="model-detail-specification-table__tooltip-wrapper">
          {row.tooltipTitle && (
            <RichText
              field={row.tooltipTitle}
              tag="h2"
              className="model-detail-specification-table__tooltip-title rich-text"
              editable={false}
            />
          )}
          {row.tooltip && (
            <RichText field={row.tooltip} tag="h2" className="model-detail-specification-table__tooltip-body rich-text" editable={false} />
          )}
        </div>
      </InfoToolTip>
    </>
  );
};

export default TableLeftMostCell;
